/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-05-14 17:25:04
 * @FilePath: \crane-safety-manager\src\helpers\api_helper.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';

import { getLoggedInUser } from './auth_helper';

axios.defaults.baseURL = '/api/v2';
// axios.defaults.baseURL = 'http://localhost:20021/';
axios.defaults.headers.post['Content-Type'] = 'application/json';

/**
 * Sets the default authorization
 * @param {string} token
 */
function setAuthorization(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

(function trySetAuthorization() {
    const authUser = getLoggedInUser() || {};
    const token = authUser.token;
    if (!token) {
        return;
    }

    setAuthorization(token);
})();

const APIClient = axios;

export { APIClient, setAuthorization };
